import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { jsPDF } from 'jspdf';
import { removeObject, returnFound } from 'find-and';
import { OverlaySideFormService } from '../components/shared/overlay-side-form/overlay-side-form.service';
import { AnteprimaPDfComponent } from '../components/shared/anteprima-pdf/anteprima-pdf.component';
import { ComicSansMS } from "../../assets/fonts/pdf-fonts/ComicSansMS-normal.js"; //Le costanti esportate da questi files, sono string in formato base64 dei corrispettivi file .ttf
import { ComicSansMSBold } from '../../assets/fonts/pdf-fonts/ComicSansMS-bold.js';
import { Subject } from 'rxjs';
import { ComponentService } from './component.service';
import { QRCode, create, toCanvas } from 'qrcode';
import { ISoggettoAbbinato } from '../class/ISoggettoAbbinato';
import { resolve } from 'url';
import { AnaUnitaLocaliComponent } from '../views/ana-soggetto/ana-unita-locali/ana-unita-locali.component';
import { Utenteservice } from './utente.service';
import { AutoTablePDFConfig } from '../components/shared/anteprima-pdf/AutoTablePDFConfig';
import { messagefromComponent } from '../class/appinterface';
import autoTable, { ColumnInput, RowInput } from 'jspdf-autotable';

import { censimento, errori_rentri } from '../../assets/test_errori_rentri';
import { test_contratto_array } from '../../assets/test_contratto';

export interface IModelloStampa {
  versione?: any;
  id?: number;
  nomeModello: string;
  idCategoriaModello: string;

  json?: string; // items stringhifati
  htmlText?: string; // inner html

  formato: string;
  orientamento: 'l' | 'p'; //tipo string con union type

  guidCreazione?: string;
}
/*
export const Categorie:[number,string] {
   
}
*/

/** Per effettuare merge multipli */
declare var PDFLib;

export interface ModelloStampaItem {

  id: string;

  tipo: 'lineaOrizzontale' | 'lineaVerticale' | 'testo' | 'cornice' | 'immagine' | 'variabile' | 'immagine-qr';

  posizione: {
    x: number;
    y: number;
  }

  contenuto: any;

  variabile?: string;

  rangeCaratteri?: {
    inizio: number;
    fine: number;
  };

  isInHeader?: boolean;
  isInFooter?: boolean;

  stile?: {
    coloreTesto?: string;
    coloreSfondo?: string;
    coloreBordo?: string;
    stileBordo?: string;
    famigliaFont?: string;
    grandezzaFont?: number;
    allineamento?: 'l' | 'c' | 'r' | 'j';
    aspetto?: {
      bold?: boolean;
      italic?: boolean;
      underline?: boolean;
      strike?: boolean;
    },
    larghezzaContainer?: string; //in pixel
    altezzaContainer?: string; //in pixel

  }

}

export enum Categorie {
  REGISTRO_DI_CARICO_E_SCARICO = '100',
  REGISTRO_DI_CARICO_E_SCARICO_RENTRI = '500',
  REGISTRO_DI_CARICO_E_SCARICO_GLOBALI = "('500','100')",
  FORMULARI = '200',
  MOVIMENTI = '300',
  ANAGRAFICHE = '400',
  REGISTRO_RENTRI = '500',
  AUTOMEZZI = '600',
  AUTISTI = '700',
  CRM_CONTATTI = '800',
  ERRORI_RENTRI = '900',
  CENSIMENTO = '1000',
}

const asterischi: string = "**********************************************************************************************************************************************************************************************************************************************************";



@Injectable({
  providedIn: 'root'
})


export class ModelliStampaService {

  pdf?: jsPDF;
  numeroPaginaProg: number = 1;
  eliminaUltimaPagina?: boolean = false;
  modelloDiStampaCaricato?: IModelloStampa;
  numeroTotaleCarichiAbbinati: number = 50;
  onAperturaPreview: Subject<any> = new Subject();

  constructor(private httpClient: HttpClient, private overlaySidePanelService: OverlaySideFormService, private componentService: ComponentService, private utenteService: Utenteservice) {

    const tipoUtenteConnesso = this.utenteService.DammiTipoUtente();

    if (tipoUtenteConnesso == 1 || tipoUtenteConnesso == 2)
      return;

    this.importMergerAndModels();

  }

  public async getSezioniByCategoria(idCategoria: string): Promise<any[]> {


    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`SezioneModello?idCategoria=${idCategoria}`)).pipe(
      map(dati => dati.items)
    ).toPromise();

    return ris;
  }

  public async getVariabili(idCategoria: string): Promise<any[]> {

    let res = [];

    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`VariabileModello?idCategoria=${idCategoria}`)).pipe(
      map(dati => dati.items)
    ).toPromise();

    //console.log(ris);


    for (let obj of ris) {

      if (!obj['visibile'])
        continue;

      res.push(obj);
    }

    return res;
  }


  private caricaFonts(pdf: jsPDF): void {

    pdf.addFileToVFS("Comic Sans MS-normal.ttf", ComicSansMS);
    pdf.addFileToVFS("Comic Sans MS-bold.ttf", ComicSansMSBold);
    //pdf.addFileToVFS("Comic Sans MS-italic.ttf",ComicSansMSItalic);

    //pdf.addFont("Comic Sans MS-normal.ttf","Comic Sans MS","normal");
    pdf.addFont("Comic Sans MS-bold.ttf", "Comic Sans MS Bold", undefined, "bold");
    pdf.addFont("Comic Sans MS-italic.ttf", "Comic Sans MS Italic", "italic");
    //pdf.addFont("Comic Sans MS","Comic Sans MS Bold","normal","bold");


  }


  public async getLunghezzaMassimaVariabile(id: string): Promise<number> {

    let variabile = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`VariabileModello/${id}`)).toPromise();

    if (variabile)
      return variabile.lunghezza;

    /*
    for(let i = 0 ; i < variabili.length;i++){

      if(variabili[i].idFieldDTB.toLowerCase() == field.toLowerCase()){
          return variabili[i].lunghezza;
        
      }

    }
    */


  }

  private buildAutoTable(config: AutoTablePDFConfig, title: string) {

    const doc = new jsPDF({
      orientation: config.Page.orientamento,
      format: config.Page.formato,
      unit: 'px'
    });

    let columns: ColumnInput[] = this.getColumnInputArray(config);
    let rows: RowInput[] = this.getRowInputArray(config);

    //Se hai passato dei dati, puoi usarli per generare una tabella
    if (config.Rows && config.Rows.length > 0 && config.Headers && config.Headers.length > 0) {

      autoTable(doc, {
        columns,
        body: rows,
        startY: 20,
        styles: {
          fontSize: 8,
          cellPadding: 3
        },
        headStyles: {
          fillColor: [66, 139, 202],
          textColor: 255
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240]
        },
        // Imposta la dimensione delle celle in base al contenuto
        columnStyles: {
          // Puoi personalizzare lo stile di specifiche colonne qui se necessario
        }
      });
    }

    // Salva il PDF con nome file
    doc.save(`${title}.pdf`);
  }

  /** Apre in un popup un pdf generato con AutoTable a partire da un JSON */
  public async generaPDFAutoTable(config: AutoTablePDFConfig, title?: string, generationOption: 'preview' | 'download' = 'preview'): Promise<void> {

    if (!config)
      return;

    switch (generationOption) {

      case 'preview': {

        let instanceData = {
          jsonDaEsterno: JSON.stringify(config),
          isCreatedThroughTemplate: true,
          height: '80vh',
          $title: title,
          tipoFile: 'application/pdf',
        };

        const id = 'AnteprimaPDfComponent';

        title = title ? title : 'Anteprima di Stampa';

        this.componentService.setNewPopUp(id, 'AnteprimaPDfComponent', [], '90vw', null, instanceData, true, true, title, 'top')

        this.componentService.outputComponent.subscribe(currentOutput => {
          if (currentOutput.guid == id) {

            if (currentOutput.name == "close") {
              this.componentService.destroyCurrentOpenPopUpByGuid(id);
              this.componentService.destroyOutputComponent();
            }
          }
        });


      } break;
      case 'download': {

        this.buildAutoTable(config, title)

      } break;
    }




  }

  /** DA RIVEDERE Dati da mostrare nella selezione dei movimenti del registro da stampare */
  public async getAllMovimentiRegistri(idRegistro: number, dataInizio: Date, dataFine: Date): Promise<any[]> {



    let ris = await this.httpClient.get<any[]>(environment.BASE_API_URL.concat(`RegistroRifiuti/GetAllMovimentiRegistri?idRegistro=${idRegistro}&dataInizio=${dataInizio}&dataFine=${dataFine}`)).toPromise();


    return ris;


  }




  /** Serve solo per effettuare test e prove di stampa nell'editor dei modelli di stampa */
  public async getMockData(categoriaModello: Categorie, filtri?: string, obj?: any): Promise<any[]> {

    let res = [];


    //UN CONTROLLER (es movimentoRifiuti) PUO' AVERE UN ACTION GetDataTable, qui è scritto fisso ma dovrà essere variabile
    let array: any[] = [];



    switch (categoriaModello) {

      case Categorie.FORMULARI: {

        array = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`DocumentoRifiuti/GetAllExtend${filtri ? filtri : ''}`)).pipe( //${ODataQueryString ? ODataQueryString : ''} /GetDataTable
          map(dati => dati.items ? dati.items : dati)
        ).toPromise();

      } break;

      case Categorie.MOVIMENTI: {

        array = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`MovimentoRifiuti/GetAllExtend${filtri ? filtri : ''}`)).pipe( //${ODataQueryString ? ODataQueryString : ''} /GetDataTable
          map(dati => dati.items ? dati.items : dati)
        ).toPromise();

      } break;

      case Categorie.CRM_CONTATTI: {
        array = test_contratto_array as any[]
      } break;

      case Categorie.REGISTRO_RENTRI: {

        array = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`RenEsportazioni/GetElencoMovimentiById/6`)).pipe( //${ODataQueryString ? ODataQueryString : ''} /GetDataTable
          map(dati => dati.items ? dati.items : dati)
        ).toPromise();

      } break;
      case Categorie.ERRORI_RENTRI: {

        array = censimento as any[]

      } break;
    }


    for (let obj of array) {

      let tempoObj: any = {};


      for (let key of Object.keys(obj)) {

        let keyCapitalized = key.charAt(0).toUpperCase() + key.slice(1);  //

        if (!obj[key]) {

          tempoObj[`${keyCapitalized}`] = undefined;

          continue;
        }


        if (Array.isArray(obj[key])) {



        }
        else
          switch (typeof obj[key]) {

            case 'object': {

              for (let nestedKey of Object.keys(obj[key])) {

                if (typeof obj[key][nestedKey] == 'object')
                  continue;


                let newKeyNestedCapitalized = nestedKey.charAt(0).toUpperCase() + nestedKey.slice(1);

                tempoObj[`${keyCapitalized}_${newKeyNestedCapitalized}`] = obj[key][nestedKey];

              }
            } break;
            default: {

              tempoObj[`${keyCapitalized}`] = obj[key];

            }
          }



      }


      res.push(tempoObj);

    }

    /* 
    if(obj['idStatoFisico'] && obj['idStatoFisico'].length>0){

      let statoFisicoDescrizione = await this.getStatoFisicoById(obj['idStatoFisico']);


      obj['idStatoFisico'] = statoFisicoDescrizione;

    }
    else if(obj['IdStatoFisico'] && obj['IdStatoFisico'].length>0){

      let statoFisicoDescrizione = await this.getStatoFisicoById(obj['IdStatoFisico']);
 

      obj['IdStatoFisico'] = statoFisicoDescrizione;

    }
    */
    return res;
  }
  /*
  this.activatedRoute.queryParams.subscribe(
    (params)=>{

      console.log(params);

      let localStorageItem = JSON.parse(localStorage.getItem(params.service.concat('Filtri')));  


      if(!localStorageItem)
        return res;


      if(localStorageItem.data){
  
  
        console.log('sto per costruire i filtri', localStorageItem.data);
  
  
        let filtriDs = [];  
  
       
  
        /*
        let dataSource : DataSource = new DataSource(
          {
            store:res,
            filter:[]
          }
        );
        
      }
      */

  public getColumnInputArray(configAutoTable: AutoTablePDFConfig) {

    let res: ColumnInput[] = [];

    if (configAutoTable.Headers) {

      for (let header of configAutoTable.Headers) {

        let colonna: ColumnInput = {
          header: header.caption,
          dataKey: header.field,
          // key: header.field,
        }
        res.push(colonna);
      }
    }

    return res;
  }

  public getRowInputArray(configAutoTable: AutoTablePDFConfig): RowInput[] {
    let res: RowInput[] = [];

    for (let i of configAutoTable.Rows) {
      let temp: RowInput = {};
      for (let key of configAutoTable.Headers) {
        for (let entry of Object.entries(i)) {
          if (key.field.includes(entry[0])) {
            temp[entry[0]] = entry[1];
          }
        }
      }
      res.push(temp);
    }
    return res;
  }




  //Metodi per contattare il Controller dei Modelli (operazioni CRUD)

  /** Restituisce tutti i modelli di Stampa */
  public async getModelli(): Promise<IModelloStampa[]> {

    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat('ModelloDiStampa')).toPromise();


    if (ris['items'])
      return ris['items'];
    else
      return ris;
  }

  public async getModelloById(id: number): Promise<IModelloStampa> {

    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat(`ModelloDiStampa/${id}`)).toPromise();

    if (ris)
      return ris;

  }


  public async aggiungiModello(modello: IModelloStampa): Promise<IModelloStampa> {

    let ris = await this.httpClient.post<any>(environment.BASE_API_URL.concat('ModelloDiStampa'), modello).toPromise();

    return ris;
  }

  public async aggiornaModello(modello: IModelloStampa, id: number): Promise<IModelloStampa> {

    let ris = await this.httpClient.put<any>(environment.BASE_API_URL.concat((`ModelloDiStampa/${id}`)), modello).toPromise();

    if (ris)
      return ris;

  }

  public async rimuoviModello(id: number): Promise<void> {

    await this.httpClient.delete<any>(environment.BASE_API_URL.concat((`ModelloDiStampa/${id}`))).toPromise();

  }

  public async getCategorieModelli(): Promise<any> {

    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat('CategoriaModello')).toPromise();

    if (ris['items'])
      return ris['items'];
  }

  public async getCategoriaModelloById(idCategoria: string): Promise<any> {

    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat('CategoriaModello/' + idCategoria)).toPromise();

    if (ris)
      return ris;
  }


  //Metodi Vari di Supporto per la stampa 
  public async getStatoFisicoById(idStatoFisico: string): Promise<string> {

    let ris = await this.httpClient.get<any>(environment.BASE_API_URL.concat('StatoFisico/' + idStatoFisico)).pipe(
      map(risultato => risultato.descrizione)
    ).toPromise();

    //console.warn(ris);

    if (ris)
      return ris;
  }

  /** Metodo Principale per la generazione del PDF */
  public async generaPDF(dataTable: any[], modello: number | IModelloStampa, generationOption: 'preview' | 'download' | 'arraybuffer' | 'base64String' = 'download', fillWithAsterisk: boolean = true): Promise<string | ArrayBuffer | string | void> {

    //const jspdf = require("jspdf");
    this.modelloDiStampaCaricato = typeof modello == 'number' ? await this.getModelloById(modello) : modello;

    if (!this.modelloDiStampaCaricato || !dataTable)
      return;


    let itemsArray = JSON.parse(this.modelloDiStampaCaricato.json);

    let tempFoglio = document.createElement('div');

    tempFoglio.innerHTML = this.modelloDiStampaCaricato.htmlText;

    let altezzaHeader = parseInt((tempFoglio.querySelector("div[id='areaHeader']") as HTMLElement).style.height.replace('cm', '')) ? parseInt((tempFoglio.querySelector("div[id='areaHeader']") as HTMLElement).style.height.replace('cm', '')) : 0;

    let altezzaFooter = parseInt((tempFoglio.querySelector("div[id='areaFooter']") as HTMLElement).style.height.replace('cm', '')) ? parseInt((tempFoglio.querySelector("div[id='areaFooter']") as HTMLElement).style.height.replace('cm', '')) : 0;


    let bg = (tempFoglio.querySelector("div[id='divSfondoFoglio']") as HTMLImageElement) ? (tempFoglio.querySelector("div[id='divSfondoFoglio']") as HTMLImageElement).style.backgroundImage : undefined;

    let immagineDiSfondoCaricata = bg ? bg.replace('url(', '').replace(')', '').replace(/\"/gi, "") : undefined;

    if (this.modelloDiStampaCaricato !== undefined)
      this.pdf = new jsPDF({
        format: this.modelloDiStampaCaricato.formato ? this.modelloDiStampaCaricato.formato : 'a4',
        unit: "cm",
        orientation: this.modelloDiStampaCaricato.orientamento ? this.modelloDiStampaCaricato.orientamento : 'p'
      });
    else {
      this.pdf = new jsPDF({
        format: 'a4',
        unit: "cm",
        orientation: 'p'
      });
    }


    this.pdf.setProperties({
      title: this.modelloDiStampaCaricato.nomeModello ? this.modelloDiStampaCaricato.nomeModello : 'Modello senza nome',
      subject: 'RentrinCloud',
      author: 'RentrinCloud',
      keywords: 'modelli, stampa, rentrincloud',
      creator: 'Nica Informatica'
    });
    //this.caricaFonts(this.pdf);

    //let width = this.pdf.internal.pageSize.getWidth();
    //let height = this.pdf.internal.pageSize.getHeight();


    //console.log({width,height});

    //console.warn(itemsArray);

    //this.pdf.addImage("Vivifir Spurghisti-1.png", 'png', 0, 0, width, height);
    if (immagineDiSfondoCaricata) { //document.getElementById('divSfondoFoglio') 

      let width = this.pdf.internal.pageSize.getWidth();
      let height = this.pdf.internal.pageSize.getHeight();

      this.pdf.addImage(immagineDiSfondoCaricata, 'PNG', 0, 0, width, height);

    }



    let areaDettagli: ModelloStampaItem[] = JSON.parse(JSON.stringify(itemsArray.filter(item => (!item.isInHeader && !item.isInFooter))));

    /*
    const distinctPIPE = new DistinctArrayPipe();
    
    console.log('prima',areaDettagli);


    areaDettagli = distinctPIPE.transform(areaDettagli,'id');

    console.log('dopo',areaDettagli);
    */

    for (let item of itemsArray.filter(item => item.isInHeader == true || item.isInFooter == true)) {

      areaDettagli = removeObject(areaDettagli, { id: item.id });
    }



    //Prima disegno il blocco dettagli
    for (let item of areaDettagli) {



      await this.disegnaItemSuFoglio(item, itemsArray, dataTable, altezzaHeader, altezzaFooter, tempFoglio, immagineDiSfondoCaricata, fillWithAsterisk);


    }


    //Poi disegno i blocchi per header e footer
    for (let item of itemsArray.filter(item => (item.isInHeader == true || item.isInFooter == true) && (item.tipo.toLowerCase() == 'cornice' || item.tipo.toLowerCase() == 'immagine'))) {


      await this.disegnaItemSuFoglio(item, itemsArray, dataTable, altezzaHeader, altezzaFooter, tempFoglio, immagineDiSfondoCaricata, fillWithAsterisk);

    }

    //Poi scrivo il testo per header e footer
    for (let item of itemsArray.filter(item => (item.isInHeader == true || item.isInFooter == true) && item.tipo.toLowerCase() !== 'cornice')) {


      if (item.tipo == 'variabile') {
        (item as ModelloStampaItem).tipo = 'testo';

        let contenuto = Object.entries(dataTable[0]).find(x => x[0].toLowerCase().trim() == (item as ModelloStampaItem).variabile.toLowerCase().trim());

        if (typeof contenuto != "undefined" && contenuto != null)
          (item as ModelloStampaItem).contenuto = contenuto[1];


        if (!(item as ModelloStampaItem).contenuto)
          continue
      }

      await this.disegnaItemSuFoglio(item, itemsArray, dataTable, altezzaHeader, altezzaFooter, tempFoglio, immagineDiSfondoCaricata, fillWithAsterisk);


    }

    //console.warn('numero Prog:',this.numeroPaginaProg);
    //console.warn('numero pag tot:',this.pdf.getNumberOfPages());

    this.numeroPaginaProg = 1; //Resetto il progressivo counter di pagine


    if (this.eliminaUltimaPagina == true) {

      this.pdf.deletePage(this.pdf.getNumberOfPages() + 1);
      this.eliminaUltimaPagina = false;
    }



    let res = await this.generaPDFResponse(generationOption);

    //console.log(res);

    return res;
  }



  private importMergerAndModels() {


    let importFN = async () => {

      const src = 'https://unpkg.com/pdf-lib@latest/dist/pdf-lib.min.js';

      var pdfLibScript = document.createElement('script');

      pdfLibScript.src = src;

      let isScriptLoaded = false;

      for (let i = 0; i < document.head.children.length; i++) {

        if ((document.head.children.item(i) as HTMLScriptElement).src == src) {

          isScriptLoaded = true;

          break;
        }



      }

      if (!isScriptLoaded)
        document.head.appendChild(pdfLibScript);

      try {

        PDFLib = window['PDFLib'];
      }
      catch (ex) {


      } finally {


        await this.ricaricaModelliPubblici();


      }
    }


    setTimeout(importFN, 2000);

  }


  /** Da invocare una volta generati gli ArrayBuffer dalla funzione "generaPDF", passando essi come parametro alla funzione */
  public async mergePDFMultipli(pdfDaUnire: ArrayBuffer[], generationOption: 'preview' | 'download' | 'base64String' = 'preview', standardBtnBottom: Array<number> = []): Promise<string | void> {



    //console.log(PDFLib);


    const unisciPDF = async () => {
      const mergedPdf = await PDFLib.PDFDocument.create();

      for (let pdfBuffer of pdfDaUnire) {

        (pdfBuffer as any) = await PDFLib.PDFDocument.load(pdfBuffer);


        const copiedPages = await mergedPdf.copyPages(pdfBuffer, (pdfBuffer as any).getPageIndices());
        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }


      /*
      const actions = pdfDaUnire.map(async pdfBuffer => {
        const pdf = await PDFLib.PDFDocument.load(pdfBuffer);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => {
          // console.log('page', page.getWidth(), page.getHeight());
          // page.setWidth(210);
          mergedPdf.addPage(page);
        });
      });
      */


      //console.warn(actions);

      //await Promise.all(actions); non va bene, causa disordine nelle pagine




      const mergedPdfFile = await mergedPdf.save();

      return mergedPdfFile;
    }

    const mergedPdfBuffer = await unisciPDF();


    const res = await this.generaPDFResponse(generationOption, mergedPdfBuffer, standardBtnBottom);


    //document.head.removeChild(pdfLibScript);
    //console.log(res)


    if (typeof res == 'string')
      return res;
    //document.head.appendChild(pdfLibScript);






  }

  private async generaPDFResponse(generationOption: 'preview' | 'download' | 'arraybuffer' | 'base64String' = 'download', mergedPdfBuffer?: any, standardBtnBottom: Array<number> = []): Promise<string | ArrayBuffer | void> {
    switch (generationOption) {

      case 'download': {

        /*
          return {
            titolo:this.modelloDiStampaCaricato.nomeModello ? this.modelloDiStampaCaricato.nomeModello : 'Modello di Stampa senza nome',
            blob:new Blob([this.pdf.output('blob')],{type:'application/pdf'}) //Valorizzare la proprietà fileData per visualizzarlo in anteprimaPDF
          }
        */
        if (this.modelloDiStampaCaricato !== undefined)
          this.pdf.save(this.modelloDiStampaCaricato.nomeModello ? this.modelloDiStampaCaricato.nomeModello : 'Modello di Stampa senza nome');
        else
          this.pdf.save('Modello di Stampa senza nome');

        return;

      } break;
      case 'preview': {



        const blob: Blob = !mergedPdfBuffer ? this.pdf.output("blob") : new Blob([mergedPdfBuffer]);


        let instanceData = {
          isFile: true,
          height: '84vh',
          $title: this.modelloDiStampaCaricato.nomeModello ? this.modelloDiStampaCaricato.nomeModello : 'Modello di Stampa senza nome',
          tipoFile: 'application/pdf',
          caricamentoTerminato: true,
          fileURL: URL.createObjectURL(blob),
          fileData: blob,
          showToolbar: false,
          showCaptionFooter: true,
          standardBtnBottom: standardBtnBottom
        };

        const id = 'AnteprimaPDfComponent';
        let title = 'Anteprima di Stampa';

        this.componentService.setNewPopUp(id, 'AnteprimaPDfComponent', [], '90vw', null, instanceData, true, true, title, 'top')
        this.componentService.outputComponent.subscribe(currentOutput => {
          if (currentOutput.guid == id) {

            if (currentOutput.name == "close") {
              this.componentService.destroyCurrentOpenPopUpByGuid(id);
              this.componentService.destroyOutputComponent();
            }
          }
        });

        return id;

        /* 
            Vecchia procedura in disuso
  
      this.overlaySidePanelService.setTitle(this.modelloDiStampaCaricato.nomeModello ? this.modelloDiStampaCaricato.nomeModello : 'Modello di Stampa senza nome');
      this.overlaySidePanelService.setContent(AnteprimaPDfComponent);
      
      this.overlaySidePanelService.setPopupWidth(1200);
      this.overlaySidePanelService.setPopupHeight(900);
      
      
      setTimeout(() => {
  
  
        this.onAperturaPreview.next(true);
        
        this.overlaySidePanelService._hrefComponent.instance.isFile = true;
        //this.overlaySidePanelService._hrefComponent.instance.isCreatedThroughTemplate = false;
  
        this.overlaySidePanelService._hrefComponent.instance.$title = this.modelloDiStampaCaricato.nomeModello ? this.modelloDiStampaCaricato.nomeModello.concat('.pdf') : 'Modello di Stampa senza nome.pdf';
        
        this.overlaySidePanelService._hrefComponent.instance.tipoFile = 'application/pdf';
        //const blob = new Blob([this.pdf.output("blob")], { type: 'application/pdf'});
        this.overlaySidePanelService._hrefComponent.instance.caricamentoTerminato =true;
  
        const blob = this.pdf.output("blob");
  
        this.overlaySidePanelService._hrefComponent.instance.fileURL = URL.createObjectURL(blob);
        (this.overlaySidePanelService._hrefComponent.instance as AnteprimaPDfComponent).fileData =blob;
  
        (this.overlaySidePanelService._hrefComponent.instance as AnteprimaPDfComponent).apriAnteprimaDaFile();
          
        (this.overlaySidePanelService._hrefComponent.instance as AnteprimaPDfComponent).emettiChiusura.subscribe(
          (res)=>{
  
            if(res){
  
              this.overlaySidePanelService.close();
  
            }
  
  
          }
        );
        
  
      }, 200);
      this.overlaySidePanelService.show(); */


      } break;
      case 'arraybuffer': {

        const arrayBuffer: ArrayBuffer = this.pdf.output('arraybuffer');

        return arrayBuffer;
      } break;
      case 'base64String': {
        let base64String: string;
        if (mergedPdfBuffer) {
          base64String = this.arrayBufferToBase64(mergedPdfBuffer);
        } else {
          base64String = this.pdf.output('datauristring');
          if (base64String.indexOf("base64,") !== -1) {
            base64String = base64String.split("base64,").pop()!;
          }
        }

        return base64String;
      }



    }
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
      const slice = bytes.subarray(i, i + chunk);
      binary += String.fromCharCode.apply(null, slice as any);
    }
    return btoa(binary);
  }




  private async disegnaItemSuFoglio(item: ModelloStampaItem, itemsArray: any[], dataTable: any[], altezzaHeader: any, altezzaFooter: any, tempFoglio: HTMLElement, immagineDiSfondoCaricata?: string, fillWithAsterisk: boolean = true) {



    let larghezzaContainerInCM = this.convertiDaPxACm(parseFloat(item.stile.larghezzaContainer)) == 0.11 ? 0 : this.convertiDaPxACm(parseFloat(item.stile.larghezzaContainer));
    let altezzaContainerInCM = this.convertiDaPxACm(parseFloat(item.stile.altezzaContainer)) == 0.11 ? 0 : this.convertiDaPxACm(parseFloat(item.stile.altezzaContainer));

    if (isNaN(larghezzaContainerInCM))
      console.error('ATTENZIONE', larghezzaContainerInCM, item.stile.larghezzaContainer)

    //this.pdf.setFillColor(item.stile.coloreSfondo);
    // if (item.stile.coloreSfondo) {
    //   if (item.stile.coloreSfondo.toLowerCase() !== 'trasparente') {


    //     if ((item.stile.coloreSfondo).includes(','))
    //       this.pdf.setFillColor(parseInt((item.stile.coloreSfondo).split(',')[0]), parseInt((item.stile.coloreSfondo).split(',')[1]), parseInt((item.stile.coloreSfondo).split(',')[2]));
    //     else
    //       this.pdf.setFillColor(item.stile.coloreSfondo);

    //   }

    // }
    // else
    //   this.pdf.setFillColor('#00000000');


    switch (item.tipo.toLowerCase()) {

      case 'testo': {

        if (!item.isInFooter && !item.isInHeader)
          return;

        for (let i = 0; i < this.pdf.internal.pages.length; i++) {


          this.pdf.setPage(i);

          this.pdf.setLineWidth(0.02);

          this.pdf.setFontSize(item.stile.grandezzaFont);


          //Se è presente il rettangolo di sfondo       
          if (item.stile.coloreSfondo.length > 0 && item.stile.coloreSfondo.toLowerCase() !== "trasparente") {

            if ((item.stile.coloreSfondo).includes(',')) {

              const hexColor: string = this.rgbToHex(parseInt((item.stile.coloreSfondo).split(',')[0]), parseInt((item.stile.coloreSfondo).split(',')[1]), parseInt((item.stile.coloreSfondo).split(',')[2]))

              //console.log(item.stile.coloreSfondo, hexColor);

              this.pdf.setFillColor(hexColor);
            }
            else {

              const { r, g, b }: {
                r: number;
                g: number;
                b: number;
              } = this.hexToRgb(item.stile.coloreSfondo);


              this.pdf.setFillColor(r, g, b);

            }


            this.pdf.rect((item.posizione.x as number), (item.posizione.y as number), (larghezzaContainerInCM) - 0.1, (altezzaContainerInCM) - 0.1, 'F');
          }






          if ((item.stile.coloreTesto).includes(','))
            this.pdf.setTextColor(parseInt((item.stile.coloreTesto).split(',')[0]), parseInt((item.stile.coloreTesto).split(',')[1]), parseInt((item.stile.coloreTesto).split(',')[2]));
          else
            this.pdf.setTextColor(item.stile.coloreTesto);


          this.impostaFont(item.stile.famigliaFont, (item.stile.aspetto) ? item.stile.aspetto.italic : undefined, (item.stile.aspetto) ? item.stile.aspetto.bold : undefined);

          this.scriviTesto(item.contenuto, item.posizione.x, item.posizione.y, larghezzaContainerInCM, altezzaContainerInCM, item.stile.allineamento);

        }

        this.pdf.setPage(0);

      } break;

      case 'immagine': {

        if (!item.isInFooter && !item.isInHeader)
          return;


        for (let i = 0; i < this.pdf.internal.pages.length; i++) {

          this.pdf.setPage(i);

          this.pdf.setLineWidth(0.02);

          //console.log('sto disegnando immagine in header:',item);

          //this.pdf.addImage(item.contenuto,'PNG',item.posizione.x,item.posizione.y,this.convertiDaPxACm((tempFoglio.querySelector(`div[id='${item.id}']`) as HTMLElement).offsetWidth),this.convertiDaPxACm((tempFoglio.querySelector(`div[id='${item.id}']`) as HTMLElement).offsetHeight))

          this.pdf.addImage(item.contenuto, 'PNG', item.posizione.x, item.posizione.y, this.convertiDaPxACm(Number((item as ModelloStampaItem).stile.larghezzaContainer)) - 0.1, this.convertiDaPxACm(Number((item as ModelloStampaItem).stile.altezzaContainer)) - 0.1)

        }

        this.pdf.setPage(0);




      } break;

      case 'lineaverticale':
      case 'lineaorizzontale':
        {


          if (!item.isInFooter && !item.isInHeader)
            return;

          for (let i = 0; i < this.pdf.internal.pages.length; i++) {

            this.pdf.setPage(i);

            this.pdf.setLineWidth(0.01);



            this.disegnaLinea(item, larghezzaContainerInCM, altezzaContainerInCM, 0);

          }

          this.pdf.setPage(0);




        } break;

      //Anche cornice per blocco dettagli e oggetti nidificati
      case "cornice": {

        let isNidificato = false;

        for (let itemm of itemsArray) {

          if (itemm.tipo.toLowerCase() == 'cornice' && itemm.contenuto.length > 0) {

            for (let itemAnnidato of itemm.contenuto) {

              if (itemAnnidato.id == item.id) {

                isNidificato = true;

                break;
              }

            }

          }

        }

        if (item.isInHeader == true || item.isInFooter == true) {


          for (let i = 0; i < this.pdf.internal.pages.length; i++) {

            this.pdf.setPage(i);

            if ((larghezzaContainerInCM == 0 || altezzaContainerInCM == 0) && item.tipo.toLowerCase() == 'cornice')
              this.pdf.setLineWidth(0.08);
            else
              this.pdf.setLineWidth(0.02);



            this.pdf.setFontSize(item.stile.grandezzaFont);


            //Se è presente il rettangolo di sfondo
            this.disegnaCornice(item, larghezzaContainerInCM, altezzaContainerInCM, 0);



          }


        } else {

          //console.log("stile bordo:",item.stile.stileBordo);


          //se ci sono delle referenze
          if (item.contenuto && !isNidificato) {




            //Costruzione Blocchi Dettaglio
            //(item.posizione.y > this.convertiDaPxACm(document.getElementById('areaHeader').offsetHeight))
            if ((item.contenuto as any[]).length > 0 && (item.posizione.y + altezzaContainerInCM <= (this.pdf.internal.pageSize.getHeight()) - altezzaFooter)) {


              let altezzaTot = 0; //posizione Y sempre aggiornata

              let i = 1;
              let counter = 0;

              for (let dato of dataTable) {




                if ((item.posizione.y as number) + 0.1 + altezzaTot + altezzaContainerInCM < this.pdf.internal.pageSize.getHeight()) {

                  let iteraNidificati = async (nascondiVariabili: boolean) => {
                    /*
                    console.warn({
                      attuale:(item.posizione.y as number) + 0.1 + altezzaTot,
                      totale:this.pdf.internal.pageSize.getHeight()
                    })
                    */


                    this.pdf.setLineWidth(0.02);



                    if (!isNidificato)
                      this.disegnaCornice(item, larghezzaContainerInCM, altezzaContainerInCM, altezzaTot);

                    //Ora passo la scrittura delle variabili e testo

                    for (let itemAnnidato of item.contenuto) { //.filter((test) => test.tipo !== 'cornice')

                      let larghezzaContainerNidificatoInCM = this.convertiDaPxACm(parseFloat(itemAnnidato.stile.larghezzaContainer)) == 0.11 ? 0 : this.convertiDaPxACm(parseFloat(itemAnnidato.stile.larghezzaContainer));
                      let altezzaContainerNidificatoInCM = this.convertiDaPxACm(parseFloat(itemAnnidato.stile.altezzaContainer)) == 0.11 ? 0 : this.convertiDaPxACm(parseFloat(itemAnnidato.stile.altezzaContainer));

                      /*
                      console.warn({
                        larghezzaContainerNidificatoInCM,
                        altezzaContainerNidificatoInCM
                      });
                      */

                      if ((larghezzaContainerNidificatoInCM == 0 || altezzaContainerNidificatoInCM == 0) && itemAnnidato.tipo.toLowerCase() == 'cornice')
                        this.pdf.setLineWidth(0.08);
                      else
                        this.pdf.setLineWidth(0.02);

                      this.pdf.setFontSize(itemAnnidato.stile.grandezzaFont);




                      //Se è presente il rettangolo di sfondo
                      if (itemAnnidato.stile.coloreSfondo)
                        if (itemAnnidato.stile.coloreSfondo.length > 0 && itemAnnidato.stile.coloreSfondo.toLowerCase() !== "trasparente") {


                          if ((itemAnnidato.stile.coloreSfondo).includes(',')) {

                            const hexColor: string = this.rgbToHex(parseInt((itemAnnidato.stile.coloreSfondo).split(',')[0]), parseInt((itemAnnidato.stile.coloreSfondo).split(',')[1]), parseInt((itemAnnidato.stile.coloreSfondo).split(',')[2]))

                            //console.log(itemAnnidato.stile.coloreSfondo, hexColor);

                            this.pdf.setFillColor(hexColor);
                          }
                          else {

                            const { r, g, b }: {
                              r: number;
                              g: number;
                              b: number;
                            } = this.hexToRgb(itemAnnidato.stile.coloreSfondo);


                            this.pdf.setFillColor(r, g, b);

                          }

                          if (!(itemAnnidato.tipo as string).toLowerCase().startsWith('linea'))
                            this.pdf.rect((itemAnnidato.posizione.x as number), (itemAnnidato.posizione.y as number) + altezzaTot, (larghezzaContainerNidificatoInCM), (altezzaContainerNidificatoInCM), 'F');


                        }




                      if (itemAnnidato.stile.coloreTesto)
                        if ((itemAnnidato.stile.coloreTesto).includes(','))
                          this.pdf.setTextColor(parseInt((itemAnnidato.stile.coloreTesto).split(',')[0]), parseInt((itemAnnidato.stile.coloreTesto).split(',')[1]), parseInt((itemAnnidato.stile.coloreTesto).split(',')[2]));
                        else
                          this.pdf.setTextColor(itemAnnidato.stile.coloreTesto);



                      if (itemAnnidato.stile.aspetto)
                        this.impostaFont(itemAnnidato.stile.famigliaFont, itemAnnidato.stile.aspetto.italic, itemAnnidato.stile.aspetto.bold);



                      switch (itemAnnidato.tipo.toLowerCase()) {

                        case 'testo': {


                          this.scriviTesto(itemAnnidato.contenuto, itemAnnidato.posizione.x, itemAnnidato.posizione.y + altezzaTot, larghezzaContainerNidificatoInCM, altezzaContainerNidificatoInCM, itemAnnidato.stile.allineamento);

                        } break;
                        case 'variabile': {




                          if (!nascondiVariabili) {


                            let dataTableIndex = 0;

                            this.scriviVariabile(itemAnnidato, dato, altezzaTot, larghezzaContainerNidificatoInCM);

                            dataTableIndex++;
                          }
                          else {

                            if (fillWithAsterisk && (!itemAnnidato.variabile.includes('Abbinato') || !dato['ElencoProtocolliCarichiAbbinati'])) {
                              this.scriviTesto(asterischi.substring((itemAnnidato as ModelloStampaItem).rangeCaratteri.inizio, (itemAnnidato as ModelloStampaItem).rangeCaratteri.fine),
                                itemAnnidato.posizione.x, itemAnnidato.posizione.y + altezzaTot, larghezzaContainerNidificatoInCM, 0, itemAnnidato.stile.allineamento);
                            }
                          }

                        } break;
                        case 'immagine': {

                          if (i == 2)
                            console.warn(itemAnnidato)

                          //console.log('sto disegnando immagine annidata:',item,this.convertiDaPxACm((tempFoglio.querySelector(`div[id='${item.id}']`) as HTMLElement).offsetWidth),this.convertiDaPxACm((tempFoglio.querySelector(`div[id='${item.id}']`)as HTMLElement).offsetWidth));

                          this.pdf.addImage(itemAnnidato.contenuto, 'PNG', itemAnnidato.posizione.x, itemAnnidato.posizione.y + altezzaTot, this.convertiDaPxACm(Number((itemAnnidato as ModelloStampaItem).stile.larghezzaContainer)) - 0.1, this.convertiDaPxACm(Number((itemAnnidato as ModelloStampaItem).stile.altezzaContainer) - 0.1))

                        } break;
                        case 'immagine-qr': {


                          //if ((itemAnnidato.id as string).match(/(QR)|(qr)/g)) {

                          //Vado a trovare la variabile relativa al blocco per poterne poi costruire il QRCODE
                          let qrCodeEntry = Object.entries(dato).find(x => x[0].toLowerCase().includes("qr") && typeof (x[1]) == 'string');

                          if (qrCodeEntry) //Se trovo la variabile relativa
                          {

                            //const qrCodeObject: any = QRCoder.create(qrCodeEntry[1] as string);
                            //const QRCoder : any = require('qrcode');


                            const tempCanvas: HTMLCanvasElement = document.createElement('canvas') as HTMLCanvasElement;


                            const t = this;


                            toCanvas(tempCanvas, (qrCodeEntry[1] as string), function (error) {

                              t.pdf.addImage(tempCanvas, 'PNG', itemAnnidato.posizione.x, itemAnnidato.posizione.y + altezzaTot, larghezzaContainerNidificatoInCM, altezzaContainerNidificatoInCM);

                            });


                          }

                        } break;
                        case 'cornice': {

                          //console.warn('STO DISEGNANDO UNA CORNICE NIDIFICATA')
                          this.pdf.setLineWidth(0.03);


                          this.disegnaCornice(itemAnnidato, larghezzaContainerNidificatoInCM, altezzaContainerNidificatoInCM, altezzaTot);

                        } break;
                        case 'lineaverticale':
                        case 'lineaorizzontale': {

                          this.disegnaLinea(itemAnnidato, larghezzaContainerNidificatoInCM, altezzaContainerNidificatoInCM, altezzaTot);



                        } break;
                      }




                    }

                  }



                  await iteraNidificati(false);

                  let scriviCarichiAbbinati = () => {

                    this.pdf.setFontSize(6);
                    let totalePresenti = 0;

                    for (let i = 1; i < 1 + this.numeroTotaleCarichiAbbinati; i++) {

                      let itemCaricoAbbinatoTrovato = itemsArray.find(
                        (itemm: ModelloStampaItem) => {
                          return itemm.variabile == `Carico${i}Abbinato`;
                        }
                      );

                      if (!itemCaricoAbbinatoTrovato)
                        continue;

                      const index = i - 1;
                      totalePresenti++;

                      if (itemCaricoAbbinatoTrovato && (dato['ElencoProtocolliCarichiAbbinati'] as string).split('-')[index])
                        this.scriviTesto((dato['ElencoProtocolliCarichiAbbinati'] as string).split('-')[index].substring((itemCaricoAbbinatoTrovato as ModelloStampaItem).rangeCaratteri.inizio, (itemCaricoAbbinatoTrovato as ModelloStampaItem).rangeCaratteri.fine),
                          itemCaricoAbbinatoTrovato.posizione.x, itemCaricoAbbinatoTrovato.posizione.y + altezzaTot, this.convertiDaPxACm(parseFloat(itemCaricoAbbinatoTrovato.stile.larghezzaContainer)), 0, (itemCaricoAbbinatoTrovato as ModelloStampaItem).stile.allineamento);



                    }

                    //Aggiorno datatable con carichi abbinati restanti
                    if ((dato['ElencoProtocolliCarichiAbbinati'] as string).split('-').length > totalePresenti) {
                      //console.warn('prima',dato['ElencoProtocolliCarichiAbbinati'])
                      dato['ElencoProtocolliCarichiAbbinati'] = (dato['ElencoProtocolliCarichiAbbinati'] as string).split('-').slice(totalePresenti).toString().replace(/[,]/g, '-');
                      //console.warn('dopo',dato['ElencoProtocolliCarichiAbbinati'])
                      altezzaTot += altezzaContainerInCM;

                      if ((item.posizione.y as number) + 0.1 + altezzaTot + altezzaContainerInCM + altezzaFooter >= this.pdf.internal.pageSize.getHeight()) {



                        this.numeroPaginaProg++;

                        if (this.modelloDiStampaCaricato !== undefined) {


                          //console.warn('STO AGGIUNGENDO UNA PAGINA');
                          this.pdf.addPage(this.modelloDiStampaCaricato.formato ? this.modelloDiStampaCaricato.formato : 'a4', this.modelloDiStampaCaricato.orientamento ? this.modelloDiStampaCaricato.orientamento : 'p');


                        }
                        else
                          this.pdf.addPage('a4', 'p');





                        altezzaTot = 0;


                        i++;
                        this.pdf.setPage(i);

                        if (immagineDiSfondoCaricata) {

                          let width = this.pdf.internal.pageSize.getWidth();
                          let height = this.pdf.internal.pageSize.getHeight();

                          this.pdf.addImage(immagineDiSfondoCaricata, 'PNG', 0, 0, width, height);

                        }

                      }





                    }
                    else
                      dato['ElencoProtocolliCarichiAbbinati'] = undefined;
                  }


                  if (dato['ElencoProtocolliCarichiAbbinati'] && dato['ElencoProtocolliCarichiAbbinati'].length > 0 && itemsArray.some((itemm: ModelloStampaItem) => { return itemm.variabile && itemm.variabile.includes('Abbinato') })) {



                    scriviCarichiAbbinati();

                    while ((dato['ElencoProtocolliCarichiAbbinati'] != undefined)) {
                      await iteraNidificati(true);
                      scriviCarichiAbbinati();
                    }
                  }





                  //scriviCarichiAbbinati();


                  //}

                  //this.disegnaItemSuFoglio(item)









                  altezzaTot += altezzaContainerInCM;


                  //if(){

                  //Ci potrebbe servire un flag per capire quando ripetere il blocco con gli asterisci e i successivi carichi abbinati







                  //Quando ho terminato di ciclare gli elementi dal datatable, stoppo l'inserimento di una nuova pagina
                  //però se la pagina ha ancora aree libere, bisogna occuparle con blocchi ripetuti e variabili asteriscate
                  if (counter == dataTable.length - 1) {

                    while ((item.posizione.y + altezzaTot + altezzaContainerInCM <= (this.pdf.internal.pageSize.getHeight()) - altezzaFooter)) {

                      //console.log('c è ancora spazio');
                      await iteraNidificati(true);
                      altezzaTot += altezzaContainerInCM;
                    }


                    break;
                  }

                  counter++;

                  //Controllo se il contenuto supera l'altezza della pagina e in tal caso aggiungo una nuova pagina al documento



                  if ((item.posizione.y as number) + 0.1 + altezzaTot + altezzaContainerInCM + altezzaFooter >= this.pdf.internal.pageSize.getHeight()) {



                    this.numeroPaginaProg++;

                    if (this.modelloDiStampaCaricato !== undefined) {


                      //console.warn('STO AGGIUNGENDO UNA PAGINA');
                      this.pdf.addPage(this.modelloDiStampaCaricato.formato ? this.modelloDiStampaCaricato.formato : 'a4', this.modelloDiStampaCaricato.orientamento ? this.modelloDiStampaCaricato.orientamento : 'p');


                    }
                    else
                      this.pdf.addPage('a4', 'p');





                    altezzaTot = 0;


                    if (i >= dataTable.length) { // && this.dataTable.length % 2 != 0
                      //this.pdf.setPage()

                      this.pdf.deletePage(this.numeroPaginaProg--);

                      this.numeroPaginaProg = 1;


                      break;
                    }

                    i++;
                    this.pdf.setPage(i);

                    if (immagineDiSfondoCaricata) {

                      let width = this.pdf.internal.pageSize.getWidth();
                      let height = this.pdf.internal.pageSize.getHeight();

                      this.pdf.addImage(immagineDiSfondoCaricata, 'PNG', 0, 0, width, height);

                    }

                  }
                  else {

                    //Se sono alla fine dei blocchi e passo qui n dispari volte allora devo rimuovere l'ultima pagina

                    /*
                    if(logCounter == dataTable.length-1 && logCounter % 2 !== 0 && this.numeroPaginaProg % 2 == 0){
                      console.warn('splutos',this.numeroPaginaProg,i,logCounter);

                      this.eliminaUltimaPagina = true;

                      

                    }
                    else if(logCounter == dataTable.length-1 && logCounter % 2 == 0 && this.numeroPaginaProg % 2 == 0){
                      console.warn('splutos',this.numeroPaginaProg,i,logCounter);

                      this.eliminaUltimaPagina = true;

                      

                    }
                    */
                  }
                }







              }

              if ((item.posizione.y as number) + 0.1 + altezzaTot + altezzaContainerInCM < this.pdf.internal.pageSize.getHeight()) {

              }

              //this.pdf.setPage(0);
              //this.pdf.deletePage(this.numeroPaginaProg);
              //this.numeroPaginaProg = 1;
            }
          }
        }

      } break;


    }

  }

  private convertiDaPxACm(pixels: number): number {
    return parseFloat(((pixels * 0.264583) / 10).toFixed(2)); //Massimo numero di cifre decimali
  }

  private convertiDaPtACm(points: number): number {
    return parseFloat(((points * 0.035277) * 10).toFixed(2));
  }


  private scriviTesto(testo: string, x: number, y: number, larghezzaContainerInCM: number | 0, altezzaContainerInCM: number, allineamento: string) {

    let dimensioniTesto = this.pdf.getTextDimensions(testo);

    //testo = testo.trimLeft().trimRight();


    let allinea_Scrivi_A_Sinistra = () => {
      this.pdf.text(testo, x, y + dimensioniTesto.h); //{ maxWidth: larghezzaContainerInCM, lineHeightFactor: 1.35, align: "left" } (maxWidth: 0 evita il wrap del testo, per ripristinare usare larghezzaContainerInCM) 
    }

    switch (allineamento) {

      case 'l': {

        // if (dimensioniTesto.w > larghezzaContainerInCM) {

        //   //testo = testo.substring(0,this.convertiDaPxACm(dimensioniTesto.w)-(this.convertiDaPxACm(dimensioniTesto.w)-larghezzaContainerInCM));

        //   let caratteriDaTruncare = 0;

        //   let dimensionePrecedente = 0;

        //   for (let i = testo.length - 1; i > 0; i--) {

        //     let dimensioniCarattere = this.pdf.getTextDimensions(testo[i]);

        //     if ((dimensioniTesto.w - dimensioniCarattere.w - dimensionePrecedente) + x > larghezzaContainerInCM + x) {

        //       dimensionePrecedente += dimensioniCarattere.w;
        //       caratteriDaTruncare++;

        //     }
        //   }

        //   if (testo.length > 1)
        //     testo = testo.substring(0, (testo.length - 1) - caratteriDaTruncare);

        // }


        allinea_Scrivi_A_Sinistra();

      }
        break;

      case 'c': {

        /*
        if(isNaN(larghezzaContainerInCM)){

          larghezzaContainerInCM = 2;
        }*/





        let centro = ((larghezzaContainerInCM) / 2) - this.convertiDaPxACm(dimensioniTesto.w);



        if (dimensioniTesto.w > larghezzaContainerInCM) {

          //testo = testo.substring(0,this.convertiDaPxACm(dimensioniTesto.w)-(this.convertiDaPxACm(dimensioniTesto.w)-larghezzaContainerInCM));

          let caratteriDaTruncare = 0;

          let dimensionePrecedente = 0;

          for (let i = testo.length - 1; i > 0; i--) {

            let dimensioniCarattere = this.pdf.getTextDimensions(testo[i]);

            if ((dimensioniTesto.w - dimensioniCarattere.w - dimensionePrecedente) + x > larghezzaContainerInCM + x) {

              dimensionePrecedente += dimensioniCarattere.w;
              caratteriDaTruncare++;

            }
          }
          if (testo.length > 1)
            testo = testo.substring(0, (testo.length - 1) - caratteriDaTruncare);

          this.pdf.text(testo, x, y + dimensioniTesto.h);
        }
        else
          this.pdf.text(testo, x + centro - (dimensioniTesto.w / 2), y + dimensioniTesto.h);  //{ maxWidth: larghezzaContainerInCM, lineHeightFactor: 1.35, align: "center" } (maxWidth: 0 evita il wrap del testo, per ripristinare usare larghezzaContainerInCM) 



      }
        break;

      case 'r': {



        this.pdf.text(testo, x + larghezzaContainerInCM, y + dimensioniTesto.h, { maxWidth: larghezzaContainerInCM, lineHeightFactor: 1.35, align: "right" });

      }
        break;

      default: {


        allinea_Scrivi_A_Sinistra();

      }
        break;
    }

    //Resetto il font
    this.pdf.setFont(undefined, "normal");
  }

  private async scriviVariabile(item, dato: any, altezzaTot: number, larghezzaContainerInCM: number) {
    for (let prop of Object.keys(dato)) {



      if ((item.variabile as string).toUpperCase().trim() == prop.toUpperCase().trim()) {

        //console.warn('CIAOOOO');

        if (dato[prop] || typeof dato[prop] == 'number') {

          //console.warn(key.toUpperCase());

          if ((item as ModelloStampaItem).rangeCaratteri) {

            //console.warn('prima',dato[key])
            if (isNaN(dato[prop]) && !isNaN(Date.parse(dato[prop])) && (prop.toLowerCase().includes('data') || prop.toLowerCase().includes('ora'))) {

              let dateParsed = new Date(dato[prop]);

              this.scriviTesto(`${dateParsed.getDate().toString().padStart(2, '0')}-${(dateParsed.getMonth() + 1).toString().padStart(2, '0')}-${dateParsed.getFullYear()} ${dateParsed.getHours().toString().padStart(2, '0')}:${dateParsed.getMinutes().toString().padStart(2, '0')}:${dateParsed.getSeconds().toString().padStart(2, '0')}`.substring((item as ModelloStampaItem).rangeCaratteri.inizio, (item as ModelloStampaItem).rangeCaratteri.fine), item.posizione.x, item.posizione.y + altezzaTot, larghezzaContainerInCM, 0, item.stile.allineamento);


            }
            else if (typeof dato[prop] == 'boolean' && dato[prop] == true) {

              //console.warn((itemAnnidato as ModelloStampaItem).stile.allineamento)
              this.scriviTesto('X'.substring((item as ModelloStampaItem).rangeCaratteri.inizio, (item as ModelloStampaItem).rangeCaratteri.fine),
                item.posizione.x, item.posizione.y + altezzaTot, larghezzaContainerInCM, 0, (item as ModelloStampaItem).stile.allineamento);


            }
            else {


              //Specifico per i codici EER che terminano con 99
              // if (prop.toLowerCase() == 'eer_descrizione' && typeof dato['eer'] == 'string' && (dato['eer'] as string).endsWith('99'))
              //   dato[prop] = dato['descrizioneAssegnata'];


              //(itemAnnidato as ModelloStampaItem).rangeCaratteri.fine = (itemAnnidato as ModelloStampaItem).rangeCaratteri.fine;

              /*
              if(!isNaN(dato[prop])){

                dato[prop] = (dato[prop] as string).replace(/[.]/g,',');

              }
              */

              if (typeof dato[prop] == 'number') {

                if (prop.includes('quantita') || prop.includes('peso'))
                  dato[prop] = (dato[prop] as number).toFixed(3).replace(/[.]/g, ',');
                else
                  dato[prop] = (dato[prop] as number).toString();

                /*
                if(Number.isInteger(dato[prop]))
                  dato[prop] = (dato[prop] as number).toString();
                else
                  dato[prop] = (dato[prop] as number).toFixed(3).replace(/[.]/g,',');
                */
              }

              if (typeof dato[prop] == 'undefined' || dato[prop] == null)
                continue;


              let testoVariabile: string = dato[prop].toString().substring((item as ModelloStampaItem).rangeCaratteri.inizio, (item as ModelloStampaItem).rangeCaratteri.fine + 1);


              /*
              if(dato[prop].charAt((itemAnnidato as ModelloStampaItem).rangeCaratteri.fine) !== ' ' && testoVariabile.length>0){

                console.warn('operare qui '+testoVariabile)

              }
              */

              //testoVariabile = testoVariabile.replace(/^\s+/, ''); //trimstart


              this.scriviTesto(
                testoVariabile,
                item.posizione.x,
                item.posizione.y + altezzaTot,
                larghezzaContainerInCM,
                0,
                (item as ModelloStampaItem).stile.allineamento
              );



            }

            //console.warn('dopo',dato[key])

          }







        }

        break;
      }


    }
  }

  private impostaFont(family: string, italic: boolean, bold: boolean) {

    if (!family)
      family = 'Helvetica';
    else if (family.toLowerCase() == 'arial')
      family = 'Helvetica';

    if (!italic && !bold) {
      this.pdf.setFont(family, "normal");

      return;
    }


    if (italic && bold) {

      this.pdf.setFont(family, "italic", "bold");

      return;
    }


    if (italic && !bold) {

      this.pdf.setFont(family, "italic");

      return;
    }


    if (!italic && bold) {

      this.pdf.setFont(family, "normal", "bold");

      return;
    }


  }

  private disegnaLinea(item: ModelloStampaItem, larghezzaContainerInCM: any, altezzaContainerInCM: any, altezzaTot: number) {


    if (item.stile.coloreBordo) {


      if ((item.stile.coloreBordo).includes(','))
        this.pdf.setDrawColor(parseInt((item.stile.coloreBordo).split(',')[0]), parseInt((item.stile.coloreBordo).split(',')[1]), parseInt((item.stile.coloreBordo).split(',')[2]));
      else
        this.pdf.setDrawColor(item.stile.coloreBordo);



    }
    //this.pdf.setDrawColor(item.stile.coloreBordo);

    if (item.stile.stileBordo && item.stile.stileBordo.toLowerCase() == "dashed")
      this.pdf.setLineDashPattern([0.1, 0.06], 0);

    this.pdf.saveGraphicsState();

    let gState = this.pdf.GState({ opacity: 0 });

    this.pdf.setGState(gState);

    this.pdf.setLineWidth(0.04); //Spessore in unità misura in fase di dichiarazione

    this.pdf.line((item.tipo.toLowerCase() == 'lineaverticale') ? (item.posizione.x as number) + 0.03 : (item.posizione.x as number), (item.posizione.y as number) + altezzaTot, (item.posizione.x as number) + ((item.tipo.toLowerCase() == 'lineaorizzontale') ? larghezzaContainerInCM : 0.03), (item.posizione.y as number) + altezzaTot + ((item.tipo.toLowerCase() == 'lineaverticale') ? altezzaContainerInCM : 0));

    this.pdf.restoreGraphicsState();

    //Rimuovo la tratteggiatura
    this.pdf.setLineDashPattern(undefined, undefined);

  }

  private disegnaCornice(item: ModelloStampaItem, larghezzaContainerInCM: any, altezzaContainerInCM: any, altezzaTot: number) {



    if (item.stile.stileBordo.toLowerCase() == "shadow") {

      //In questo controllo devo disegnare un rettangolo grigio prima di quello effettivo in modo che simuli un ombra
      this.pdf.setFillColor("#888888");

      this.pdf.rect((item.posizione.x as number) + 0.1, (item.posizione.y as number) + 0.1 + altezzaTot, larghezzaContainerInCM, altezzaContainerInCM, 'F');


    }

    if (item.stile.stileBordo && item.stile.stileBordo.toLowerCase() == "dashed") {
      this.pdf.setLineDashPattern([0.1, 0.06], 0);
    }

    //console.log(item.stile.coloreBordo);
    if (item.stile.coloreBordo) {
      if ((item.stile.coloreBordo).includes(','))
        this.pdf.setDrawColor(parseInt((item.stile.coloreBordo).split(',')[0]), parseInt((item.stile.coloreBordo).split(',')[1]), parseInt((item.stile.coloreBordo).split(',')[2]));
      else
        this.pdf.setDrawColor(item.stile.coloreBordo);


    }

    if (item.stile.coloreSfondo !== "trasparente") {
      if ((item.stile.coloreSfondo).includes(','))
        this.pdf.setFillColor(parseInt((item.stile.coloreSfondo).split(',')[0]), parseInt((item.stile.coloreSfondo).split(',')[1]), parseInt((item.stile.coloreSfondo).split(',')[2]));
      else
        this.pdf.setFillColor(item.stile.coloreSfondo);




      //console.log(item.posizione);

      this.pdf.rect((item.posizione.x as number), (item.posizione.y as number) + altezzaTot, larghezzaContainerInCM, altezzaContainerInCM, 'FD');

    }
    else {

      this.pdf.saveGraphicsState();

      let gState = this.pdf.GState({ opacity: 0 });

      this.pdf.setGState(gState);


      this.pdf.rect((item.posizione.x as number), (item.posizione.y as number) + altezzaTot, larghezzaContainerInCM, altezzaContainerInCM, 'FD');

      this.pdf.restoreGraphicsState();

    }


    //Rimuovo la tratteggiatura
    this.pdf.setLineDashPattern(undefined, undefined);
  }


  public caricaVariabiliCarichiAbbinati(): any[] {

    let res = [];


    for (let i = 1; i < 1 + this.numeroTotaleCarichiAbbinati; i++) {

      res.push({
        id: Math.random() * 10,
        idCategoria: '100',
        idSezione: '111',
        idFieldDTB: `Carico${i}Abbinato`,
        lunghezza: 11,
        descrizione: `Carico${i}Abbinato`,
        allineamento: 'l'
      });
    }


    return res;

  }

  public getCategorie() {
    return Categorie;
  }

  /**
   * Genera la stampa del formulario Rentri, trovando le pagine relative (allegati) e in base alla 'option' si decide se stampare (download) o visualizzarne in anteprima (preview)
   * @param datiFormularioExtended 
   * @param option 
   */
  public async generaStampaFormularioRentri(datiFormularioExtended: any, option: 'download' | 'preview' | 'base64String'): Promise<any> {

    //console.log(datiFormularioExtended);

    if (!datiFormularioExtended)
      return;

    datiFormularioExtended = this.formattaSoggettiAbbinatiPerStampa(datiFormularioExtended);


    let pagineArrayBuffer: ArrayBuffer[] = [];

    const pagineModelloFormulario: {
      firstPage?: IModelloStampa,
      secondPage?: IModelloStampa,
      thirdPage?: IModelloStampa
    } = await this.httpClient.get(environment.BASE_API_URL.concat(`ModellodiStampa/GetPagineModelloVivifirRentri`)).toPromise();


    if (pagineModelloFormulario.firstPage)
      pagineArrayBuffer[0] = (await this.generaPDF([datiFormularioExtended], pagineModelloFormulario.firstPage, 'arraybuffer') as ArrayBuffer);

    if (pagineModelloFormulario.secondPage)
      pagineArrayBuffer[1] = (await this.generaPDF([datiFormularioExtended], pagineModelloFormulario.secondPage, 'arraybuffer') as ArrayBuffer);

    //Da un confronto con Ciro, se non presenti ne soggetti abbinati trasportatori ne intermediari, il terzo allegato non va stampato
    if (pagineModelloFormulario.thirdPage && ((datiFormularioExtended.listaAltriSoggettiT && datiFormularioExtended.listaAltriSoggettiT.length > 0) || (datiFormularioExtended.listaAltriSoggettiI && datiFormularioExtended.listaAltriSoggettiI.length > 0)))
      pagineArrayBuffer[2] = (await this.generaPDF([datiFormularioExtended], pagineModelloFormulario.thirdPage, 'arraybuffer') as ArrayBuffer);


    const res = await this.mergePDFMultipli(pagineArrayBuffer, option);

    if (typeof res == "string")
      return res;
  }

  /**
   * Genera la stampa del formulario Vivifir e in base alla 'option' si decide se stampare (download) o visualizzarne in anteprima (preview)
   * @param datiFormularioExtended 
   * @param option 
   */
  public async generaStampaFormularioVivifir(datiFormularioExtended: any, option: 'download' | 'preview'): Promise<any> {

    //console.log(datiFormularioExtended);

    if (!datiFormularioExtended)
      return;

    datiFormularioExtended = this.formattaListaInterventiSpurgo(datiFormularioExtended);

    const modelloVivifir: IModelloStampa = await this.httpClient.get<IModelloStampa>(environment.BASE_API_URL.concat(`ModellodiStampa/GetByGUID/47747c56-3c9e-41d8-b7e0-8bcd263597b0`)).toPromise();


    return (await this.generaPDF([datiFormularioExtended], modelloVivifir, option) as any);
  }





  /** Legge dalla cartella dei files pubblici e aggiorna i modelli pubblici per l'azienda di lavoro su cui si è loggati */
  public async ricaricaModelliPubblici(): Promise<void> {

    await this.httpClient.post<any>(environment.BASE_API_URL.concat('ModelloDiStampa/InizializzaModelliPubblici'), undefined).toPromise();

  }

  /** Funzione che formatta i dati del formulario/movimento e ne "appiattisce" le proprietà per i 4 slot disponibili nell'allegato del nuovo formulario
   * e ne restitusce nuovamenete il contentuo
   *  
   *  N.B: Viene data priorità alla stampa dei Soggetti Abbinati Trasportatore e po infine gli intermediari 
   * 
  */
  private formattaSoggettiAbbinatiPerStampa(datiFormularioExtended: any): any {

    if (!datiFormularioExtended.listaAltriSoggettiT && !datiFormularioExtended.listaAltriSoggettiI)
      return datiFormularioExtended;

    let totTrasportatoriAggiunti: number = 0;

    //Aggiunta trasportatori
    for (let i = 0; i < 4; i++) {



      //Diamo Priorità ai Soggetti Abbinati Trasportatori
      if (datiFormularioExtended.listaAltriSoggettiT[i]) {

        const operatoreIndex = i + 1;
        totTrasportatoriAggiunti++;

        const altroSoggettoTrasportatore: ISoggettoAbbinato = datiFormularioExtended.listaAltriSoggettiT[i];

        switch (altroSoggettoTrasportatore.tipoTrasporto) {

          default:
          case "1": {

            datiFormularioExtended[`Operatore${operatoreIndex}_xSeVettoreTerrestre`] = "X";

          } break;
          case "2": {

            datiFormularioExtended[`Operatore${operatoreIndex}_xSeTerminalista`] = "X";

          } break;
          case "3": {

            datiFormularioExtended[`Operatore${operatoreIndex}_xSeGestoreFerroviario`] = "X";

          } break;
          case "4": {

            datiFormularioExtended[`Operatore${operatoreIndex}_xSeGestoreMarittimo`] = "X";


          } break;

        }

        datiFormularioExtended[`Operatore${operatoreIndex}_CodiceFiscale`] = altroSoggettoTrasportatore.codiceFiscale;

        datiFormularioExtended[`Operatore${operatoreIndex}_Descrizione`] = altroSoggettoTrasportatore.descrizione;

        datiFormularioExtended[`Operatore${operatoreIndex}_AutorizzazioneAlbo`] = altroSoggettoTrasportatore.autorizzazioneAlbo;

        datiFormularioExtended[`Operatore${operatoreIndex}_TargaAutomezzo`] = altroSoggettoTrasportatore.targaAutomezzo;

        datiFormularioExtended[`Operatore${operatoreIndex}_TargaRimorchio`] = altroSoggettoTrasportatore.targaRimorchio;

        datiFormularioExtended[`Operatore${operatoreIndex}_NumeroNave`] = altroSoggettoTrasportatore.numeroNave;

        datiFormularioExtended[`Operatore${operatoreIndex}_NumeroTreno`] = altroSoggettoTrasportatore.numeroTreno;

        datiFormularioExtended[`Operatore${operatoreIndex}_NumeroNave_NumeroTreno_Full`] = altroSoggettoTrasportatore.numeroNave_NumeroTreno_Full;

        datiFormularioExtended[`Operatore${operatoreIndex}_QuantitaKg`] = altroSoggettoTrasportatore.quantitàKg;

      }

    }


    //Aggiunta intermediari 
    for (let i = 0; i < 4; i++) {

      const operatoreIndex = i + 1;


      if (i >= totTrasportatoriAggiunti && datiFormularioExtended.listaAltriSoggettiI[i - totTrasportatoriAggiunti]) {


        const altroSoggettoIntermediario: ISoggettoAbbinato = datiFormularioExtended.listaAltriSoggettiI[i - totTrasportatoriAggiunti];

        datiFormularioExtended[`Operatore${operatoreIndex}_xSeIntermediario`] = "X";

        datiFormularioExtended[`Operatore${operatoreIndex}_CodiceFiscale`] = altroSoggettoIntermediario.codiceFiscale;

        datiFormularioExtended[`Operatore${operatoreIndex}_Descrizione`] = altroSoggettoIntermediario.descrizione;

        datiFormularioExtended[`Operatore${operatoreIndex}_AutorizzazioneAlbo`] = altroSoggettoIntermediario.autorizzazioneAlbo;

      }


    }





    console.log(datiFormularioExtended);

    return datiFormularioExtended;

  }


  private formattaListaInterventiSpurgo(datiFormularioExtended: any): any {
    if (!datiFormularioExtended.listaInterventiSpurghi)
      return datiFormularioExtended;

    if (datiFormularioExtended.listaInterventiSpurghi.length == 0)
      return datiFormularioExtended;

    for (let i = 0; i < 10; i++) {


      if (datiFormularioExtended.listaInterventiSpurghi[i]) {

        datiFormularioExtended[`Intervento_Spurgo_Descrizione_${i + 1}`] = datiFormularioExtended.listaInterventiSpurghi[i].indirizzoFullProduttoreSede;
        datiFormularioExtended[`Intervento_Spurgo_Quantita_${i + 1}`] = datiFormularioExtended.listaInterventiSpurghi[i].quantita;

      }

    }

    return datiFormularioExtended;

  }


  public async mostraVariabileOrfane(items: ModelloStampaItem[]) {

    const itemsCopy = JSON.parse(JSON.stringify(items))

    let variabiliBloccoDettagli = itemsCopy.filter(
      item => !item.isInFooter && !item.isInHeader && item.tipo == 'variabile'
    );

    for (let variabile of variabiliBloccoDettagli) {

      let objFound = returnFound(itemsCopy, { id: variabile.id });

      if (!Array.isArray(objFound)) {

        console.log(objFound);

      }
    }

  }


  private rgbToHex(r: number, g: number, b: number) {
    return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase();
  }

  private hexToRgb(hex: string) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
      hex = hex.split('').map(char => char + char).join('');
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return { r, g, b };
  }

}
